import React from "react";
import { Box, Grid, Typography, Card, useMediaQuery } from "@mui/material";
import image1 from "../assets/building-icon.svg";
import image2 from "../assets/engg-doc-icon.svg";
import image3 from "../assets/teacher-icon.svg";

const Years = () => {
    const isMobile = useMediaQuery("(max-width:600px)"); // Check for mobile screen size

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mt: 4,
                backgroundColor: "#fff",
                p: isMobile ? 2 : 0, // Add padding for mobile
            }}
        >
            <Card
                sx={{
                    width: isMobile ? "100%" : "60%", // Full width on mobile, 60% on desktop
                    p: isMobile ? 2 : 4, // Reduce padding on mobile
                    borderRadius: 3,
                    boxShadow: 3,
                    textAlign: "center",
                }}
            >
                <Typography variant={isMobile ? "h6" : "h5"} sx={{ fontWeight: "bold", mb: 4 }}>
                    36+ years of legacy
                </Typography>
                <Grid container spacing={isMobile ? 2 : 4} justifyContent="center">
                    {/* Coaching Centers */}
                    <Grid item xs={12} sm={4}>
                        <Box sx={{ textAlign: "center" }}>
                            <img src={image1} alt="Coaching Centers" style={{ width: isMobile ? "50px" : "70px" }} />
                            <Typography variant={isMobile ? "h6" : "h5"} sx={{ fontWeight: "bold", mt: 1 }}>
                                400+
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                Coaching centers in India
                            </Typography>
                        </Box>
                    </Grid>

                    {/* Qualified Students */}
                    <Grid item xs={12} sm={4}>
                        <Box sx={{ textAlign: "center" }}>
                            <img src={image2} alt="Qualified Students" style={{ width: isMobile ? "50px" : "70px" }} />
                            <Typography variant={isMobile ? "h6" : "h5"} sx={{ fontWeight: "bold", mt: 1 }}>
                                131,700+
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                Aakashians qualified NEET & JEE in 2024
                            </Typography>
                        </Box>
                    </Grid>

                    {/* Expert Faculty */}
                    <Grid item xs={12} sm={4}>
                        <Box sx={{ textAlign: "center" }}>
                            <img src={image3} alt="Expert Faculty" style={{ width: isMobile ? "50px" : "70px" }} />
                            <Typography variant={isMobile ? "h6" : "h5"} sx={{ fontWeight: "bold", mt: 1 }}>
                                5000+
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                Expert Faculty
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Card>
        </Box>
    );
};

export default Years;